import type { ModuleKey } from "../../shared/modules";

/**
 * Testi della sezione Supporto.
 *
 * Vivono qui, fuori dalla schermata, perche non sono grafica: sono il manuale del prodotto.
 * Ogni voce puo dichiarare un `module`, e allora si vede **solo alle aziende che quel modulo
 * ce l'hanno acceso**. E la regola che gia governa il menu: promettere per iscritto una
 * funzione che l'azienda non ha comprato e peggio che non spiegarla, perche chi legge la
 * cerca, non la trova e telefona.
 */
export type SupportEntry = {
  label: string;
  testo: string;
  module?: ModuleKey;
};

export type SupportQuestion = {
  label: string;
  risposta: string;
  module?: ModuleKey;
};

export const GUIDA: SupportEntry[] = [
  {
    label: "Strutture",
    testo: "Sono i luoghi dove lavorate: residence, condomini, alberghi, ville e case private. Ogni struttura tiene insieme indirizzo, referente e storico degli interventi, così non serve più cercare fra messaggi e foglietti.",
  },
  {
    label: "Squadra",
    testo: "Le persone che lavorano con voi, ognuna con il proprio ruolo. Al collaboratore potete decidere se far vedere tutte le strutture oppure solo quelle che gli avete assegnato.",
  },
  {
    label: "Interventi",
    testo: "Il lavoro vero e proprio: quando si va, dove, chi ci va e cosa c'è da fare. Sul posto si avvia il timer, si spuntano le attività, si scattano le fotografie. Le ore si possono anche correggere a mano, e la correzione resta tracciata.",
  },
  {
    label: "Materiali",
    testo: "Quello che serve in cantiere. Il collaboratore segnala cosa manca anche senza campo, la richiesta parte appena torna la linea. Poi si segna quanto è stato ordinato, quanto è arrivato e quanto è stato usato.",
  },
  {
    label: "Fornitori",
    testo: "La rubrica di chi vi vende i materiali, con i listini. I prezzi restano storicizzati e il confronto li mette a paragone sul costo per unità, così si vede davvero chi costa meno a parità di prodotto.",
  },
  {
    label: "Settimana",
    testo: "La vista a settimana per collaboratore: chi fa cosa e in quale giorno. I giri fissi si ripetono da soli, da ogni settimana fino a ogni otto, e generano gli interventi futuri senza riscriverli ogni volta.",
    module: "weekly_schedule",
  },
  {
    label: "Piscine",
    testo: "Il registro delle vasche: cloro, pH, pulizia filtri e skimmer, carico cloro e reintegro d'acqua in litri. Ogni struttura tiene il suo storico e il foglio si stampa come quello di carta, da lasciare al condominio.",
    module: "pool_log",
  },
];

export const DOMANDE: SupportQuestion[] = [
  {
    label: "Il collaboratore può vedere i prezzi?",
    risposta: "No. Prezzi, listini, confronti e ordini restano a titolare e responsabile. Il collaboratore vede il lavoro da fare e segnala i materiali che servono.",
  },
  {
    label: "Cosa succede se in cantiere non c'è campo?",
    risposta: "Si continua a lavorare. Le richieste di materiale e le fotografie restano in coda sul telefono e vengono inviate da sole appena torna la connessione.",
  },
  {
    label: "L'app invia l'ordine al fornitore da sola?",
    risposta: "No, e non è un errore: prepara l'email già scritta e la apre nella vostra applicazione di posta. Siete voi a rileggerla e inviarla. Lo stato dell'ordine cambia solo quando confermate di averla mandata.",
  },
  {
    label: "Posso installare MANUTIO come un'app sul telefono?",
    risposta: "Sì. Aprite l'indirizzo con Safari su iPhone o iPad, toccate Condividi e poi Aggiungi alla schermata Home. Da lì si apre come una normale applicazione.",
  },
  {
    label: "Perché il timer chiede la posizione?",
    risposta: "Serve solo a registrare dove è iniziato e finito il lavoro, e viene letta soltanto in quei due momenti. Se rifiutate il permesso si lavora lo stesso.",
  },
  {
    label: "Ho corretto le ore per sbaglio, si perde il dato di prima?",
    risposta: "No. Ogni correzione conserva il valore precedente e il motivo, quindi si può sempre ricostruire cosa era stato registrato.",
  },
  {
    label: "Un'altra azienda può vedere i nostri dati?",
    risposta: "No. Ogni azienda è separata dalle altre, sia nell'applicazione sia nel database.",
  },
  {
    label: "L'ordine parte davvero da solo al fornitore?",
    risposta: "Sì, quando il modulo Email automatiche è acceso: l'app spedisce l'ordine e ne tiene il registro. Lo stato passa a inviato soltanto se l'email è partita davvero; se qualcosa non va, l'ordine resta dov'era e il motivo resta scritto.",
    module: "email_automation",
  },
  {
    label: "Un giro fisso saltato si recupera?",
    risposta: "L'occorrenza già programmata resta dov'è e si può spostare aprendo l'intervento. Fermare un giro tocca solo le date future ancora intatte: quello di oggi può essere già in viaggio verso la struttura.",
    module: "weekly_schedule",
  },
  {
    label: "I valori fuori soglia bloccano il salvataggio?",
    risposta: "No. Un cloro alto o un pH basso vengono segnalati a schermo ma la rilevazione si salva lo stesso: è un numero da guardare, non un errore da correggere prima di andare avanti.",
    module: "pool_log",
  },
];
